import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { ProtectedRoute } from "./component/protected-route";
import { Menus } from "./helper/constants/enums";
import { ReducerStateContant } from "./helper/constants/general-const";
import WithLoading from "./component/shared/WithLoading";
import RouteLoader from "./component/shared/RouteLoader";
import { useAuth } from "./hooks/useAuth";
import Layout from "./component/shared/Layout";

const AppRoutes = () => {
    const Business = WithLoading(React.lazy(() => import("./pages/settings/business/Business")));
    // const BusinessCategory = WithLoading(React.lazy(() => import("./pages/settings/business/businessCategory/BusinessCategory")));
    const CustomerBusiness  = WithLoading(React.lazy(() => import("./pages/settings/business/customerbusiness/OtherShop")));
    const Users = WithLoading(React.lazy(() => import("./pages/settings/users/Users")));
    const Roles = WithLoading(React.lazy(() => import("./pages/settings/groups/Groups")));
    const Department = WithLoading(React.lazy(() => import("./pages/products/department/Department")));
    const SubDepartment = WithLoading(React.lazy(() => import("./pages/products/sub-department/SubDepartment")));
    const Brands = WithLoading(React.lazy(() => import("./pages/products/brands/Brands")));
    const Tax = WithLoading(React.lazy(() => import("./pages/settings/tax/Tax")));
    const Unit = WithLoading(React.lazy(() => import("./pages/products/unit/Unit")));
    const PageNotFound = WithLoading(React.lazy(() => import("./pages/PageNotFound")));
    const Products = WithLoading(React.lazy(() => import("./pages/products/products/Products")));
    const BulkProducts = WithLoading(React.lazy(() => import("./pages/products/bulk-products/BulkProducts")));
    const Announcement = WithLoading(React.lazy(() => import("./pages/webContentsSettings/Announcements/Announcements")));
    const HomeBanners = WithLoading(React.lazy(() => import("./pages/webContentsSettings/homeBanners/HomeBanners")));
    const MenuSettings = WithLoading(React.lazy(() => import("./pages/webContentsSettings/MenuSettings/MenuSettings")));
    const PromotionCategory = WithLoading(React.lazy(() => import("./pages/promotions/promotionCategory/PromotionCategory")));
    const AccessDenied = WithLoading(React.lazy(() => import("./component/shared/AccessDenied")));
    const Promotion = WithLoading(React.lazy(() => import("./pages/promotions/promotion/promotion")));
    // const Shippingzones = WithLoading(React.lazy(() => import("./pages/settings/shippingzones/shippingzones/shippingzones")));
    // const Holiday = WithLoading(React.lazy(() => import("./pages/settings/shippingzones/holiday/holiday")));
    const Orders = WithLoading(React.lazy(() => import("./pages/orders/Orders")));
    const ChildShopOrder = WithLoading(React.lazy(() => import("./pages/childshoporder/ChildShopOrder")));
    const Customers = WithLoading(React.lazy(() => import("./pages/customers/Customers")));
    const SlotConfiguration = WithLoading(React.lazy(() => import("./pages/slotmanagement/slotConfiguration/SlotConfiguration")));
    const ManageSlot = WithLoading(React.lazy(() => import("./pages/slotmanagement/slotManage/manageSlot")));
    const ExceptionSlot = WithLoading(React.lazy(() => import("./pages/slotmanagement/slotException/exceptionSlot")));
    const Dashboard = WithLoading(React.lazy(() => import("./pages/dashboard/dashboard")));
    const SalesSummary = WithLoading(React.lazy(() => import("./pages/reports/salesSummary/SalesSummary")));
    const ProductSalesSummary = WithLoading(React.lazy(() => import("./pages/reports/productSalesSummary/ProductSalesSummary")));
    const ProductRefundSummary = WithLoading(React.lazy(() => import("./pages/reports/productRefundSummary/ProductRefundSummary")));
    // const InvoiceCommission  = WithLoading(React.lazy(() => import("./pages/reports/invoicecommission/InvoiceCommission")));
    const DeliveryCollection = WithLoading(React.lazy(() => import("./pages/reports/deliveryCollection/DeliveryCollection")));
    const MissingProducts = WithLoading(React.lazy(() => import("./pages/products/missing-products/MissingProducts")));
    const PickerUsers = WithLoading(React.lazy(() => import("./pages/settings/pickerusers/PickerUser")));
    const DriverUsers = WithLoading(React.lazy(() => import("./pages/settings/driverusers/DriverUser")));
    const PointConfiguration = WithLoading(React.lazy(() => import("./pages/settings/pointConfiguration/PointConfiguration")));

    const { user, tokenDetails } = useAuth();

    const protectedLayout = user && tokenDetails ? <Layout /> : <RouteLoader />;

    return (
        <Routes>
            <Route path="/" element={protectedLayout}>
                <Route index element={<Dashboard />} />
                <Route path="/admin">
                    <Route index element={<PageNotFound />} />
                    <Route path={Menus.dashboard} element={<Dashboard />} />
                    <Route path={Menus.Orders}>
                        <Route path={Menus.Orders} element={<Orders />} />
                        <Route path={Menus.ChildShopOrder} element={<ChildShopOrder />} />
                        <Route path={Menus.DeliveryCollection} element={<DeliveryCollection />} />
                    </Route>
                    <Route path={Menus.Customers} element={<Customers />} />
                    <Route path={Menus.SlotManagement}>
                       <Route path={Menus.SlotConfiguration} element={<SlotConfiguration />} />
                       <Route path={Menus.ManageSlot} element={<ManageSlot />} />
                       <Route path={Menus.ManageSlotExceptions} element={<ExceptionSlot />} />
                    </Route>
                    
                    <Route path={Menus.settings}>
                        {/* <Route path={Menus.ShippingZones}>
                            <Route path={Menus.ShippingZones} element={<Shippingzones />} />
                            <Route path={Menus.Holiday} element={<Holiday />} />
                        </Route> */}
                        {/* <Route path={Menus.Business} element={<Business />} /> */}
                        <Route path={Menus.Business}>
                            <Route path={Menus.Business} element={<Business />} />
                            {/* <Route path={Menus.BusinessCategory} element={<BusinessCategory />} /> */}
                            <Route path={Menus.CustomerBusiness} element={<CustomerBusiness />} />
                        </Route>
                        <Route path={Menus.users}>
                            <Route path={Menus.UserManagement} element={<Users />} />
                            <Route path={Menus.RoleManagement} element={<Roles />} />
                        </Route>
                        <Route path={Menus.Tax} element={<Tax />} />
                        <Route path={Menus.PickerUsers} element={<PickerUsers />} />
                        <Route path={Menus.DriverUsers} element={<DriverUsers />} />
                        <Route path={Menus.PointConfiguration} element={<PointConfiguration />} />
                    </Route>
                    <Route path={Menus.Products}>
                        <Route path={Menus.Products} element={<Products />} />
                        <Route path={Menus.BulkProducts} element={<BulkProducts />} />
                        <Route path={Menus.Departments}>
                            <Route path={Menus.Departments} element={<Department />} />
                            <Route path={Menus.SubDepartments} element={<SubDepartment />} />
                            <Route path={Menus.Brands} element={<Brands />} />
                            <Route path={Menus.Units} element={<Unit />} />
                        </Route>
                        <Route path={Menus.MissingProduct} element={<MissingProducts />} />
                    </Route>
                    <Route path={Menus.Promotions}>
                        <Route path={Menus.Promotions} element={<Promotion />} />
                        <Route path={Menus.PromotionCategory} element={<PromotionCategory />} />
                    </Route>
                    <Route path={Menus.webContentsSettings}>
                        <Route path={Menus.Announcements} element={<Announcement />} />
                        <Route path={Menus.HomeBanners} element={<HomeBanners />} />
                        <Route path={Menus.MainMenusettings} element={<MenuSettings />} />
                    </Route>
                    <Route path={Menus.Reports}>
                        <Route path={Menus.SalesSummary} element={<SalesSummary />} />
                        <Route path={Menus.ProductSalesSummary} element={<ProductSalesSummary />} />
                        <Route path={Menus.ProductRefundSummary} element={<ProductRefundSummary />} />
                        {/* <Route path={Menus.InvoiceCommission} element={<InvoiceCommission />} /> */}
                    </Route>
                    <Route path="*" element={<PageNotFound />} />
                </Route>
            </Route>
            <Route path="/accessdenied" element={<AccessDenied />} />
        </Routes>
    );
};

export default AppRoutes;
